<template>
    <v-dialog
        v-model="dialog"
        fullscreen
    >
        <v-card>
            <v-toolbar
                dark
                color="primary"
            >
                <v-toolbar-title>Custom Message</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn
                        dark
                        text
                        @click="onClickDeleteCustomMessage"
                    >
                        Delete Custom Message
                    </v-btn>

                    <v-btn
                        dark
                        text
                        @click="onClickDiscardChanges"
                    >
                        Discard
                    </v-btn>

                    <v-btn
                        dark
                        text
                        @click="onClickSave"
                        :disabled="!valid"
                    >
                        Save
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text>

                <v-form
                    v-model="valid"
                >
                    <v-textarea
                        autofocus
                        auto-grow
                        rows="1"
                        :hint=hint
                        v-model="message"
                        :rules="[rules.no_pay_links]"
                    />
                </v-form>

                <div
                    style="text-align: right"
                >
                    <v-btn
                        color="primary"
                        style="margin-top: 15px;"
                        v-on:click="onClickSave"
                        :disabled="!valid"
                    >
                        Save
                    </v-btn>
                </div>

            </v-card-text>

        </v-card>
    </v-dialog>
</template>

<script>

export default {
    props: {
        hint : {
            type: String,
            default: function() { return "Type or copy/paste your message here.  Use enter to add newlines.  Field will auto-grow to contain your content."; }
        },
    },

    data() {
        return {
            dialog: false,
            is_valid: true,
            message: '',
            bulk_message_recipient_id: null,
            valid: false,

            rules: {
                no_pay_links: (value) => {
                    if ( value == null ) return true;

                    let normalized_text = value.toLowerCase().trim();
                    if ( normalized_text.indexOf('redchirp.com/app/pay/') >= 0 )
                    {
                        return 'Message cannot contain pay links: https://app.redchirp.com/app/pay';
                    }
                    return true;
                },
            },
        }
    },

    methods: {

        showDialog(bulk_message_recipient_id, message)
        {
            if ( message != null )
            {
                this.message = message.trim();
            }
            else
            {
                this.message = '';
            }

            this.bulk_message_recipient_id = bulk_message_recipient_id;
            this.dialog = true;
            this.$router.dialog_guard = this.dialogGuard;
        },

        closeDialog()
        {
            this.dialog = false;
            this.$router.dialog_guard = null;
        },

        dialogGuard(to, from, next)
        {
            if ( this.dialog == false)
            {
                // slipup somehow
                this.$router.dialog_guard = null;
                return;
            }

            // The dialog is showing...
            if ( this.is_valid )
            {
                this.dialog = false;
                next(false);
                return;
            }

            this.$rc.snackbar('You must either correct the errors or discard your changes.',1500);
            this.dialog = true;
            next(false);
        },

        onClickSave()
        {
            this.save();
            this.closeDialog();
        },

        onClickDiscardChanges()
        {
            this.closeDialog();
        },

        onClickDeleteCustomMessage()
        {
            this.$rc.confirm(
                'Delete Custom Message',
                'Deleting this custom message will make the recipient receive the standard Message Text from the ' +
                'bulk message.',
                [
                    {'text': 'Cancel', 'value': 'cancel'},
                    {'text': 'Confirm', 'value': 'confirm'},
                ],

                (response) => {
                    if (response == 'confirm') {
                        this.message = null;
                        this.$emit('ok',this.bulk_message_recipient_id, this.message);
                        this.closeDialog();
                    } else {
                        return;
                    }
                }

            );
        },

        save()
        {
            if ( this.message != null )
            {
                this.message = this.message.trim();

                // if only white space, reset to null
                if ( this.message === '' )
                {
                    this.message = null;
                }
            }

            this.$emit('ok',this.bulk_message_recipient_id, this.message);
        },

    },
}
</script>

<style lang="scss" scoped>
</style>